<template>
  <TransitionGroup
    tag="div"
    class="notifications"
    name="slide-fade"
  >
    <NotificationToast
      v-for="notification in uiNotifications"
      :id="notification.id"
      :key="notification.id"
      :title="notification.message"
      :subtitle="notification.subtitle"
      :ending-link-text="notification.endingLinkText"
      :ending-link-slug="notification.endingLinkSlug"
      :date="notification.date"
      :status="notification.type"
      @click:close="notification.dismiss"
    />
  </TransitionGroup>
</template>

<script lang="ts">


export default defineComponent({
  name: 'NotificationToastWrapper',

  setup () {

    const { uiNotifications } = useUiNavigationStore();

    return {
      uiNotifications,
    };
  
  },
});

</script>

<style scoped lang="scss">
@use "~/assets/scss/helpers/_breakpoints" as breakpoints;
.notifications {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 51;

  @include breakpoints.for-desktop {
    top: 100px;
    left: auto;
    bottom: auto;
    right: 5%;
    width: 320px;
  }
}

.sf-notification {
  max-width: 100%;
  margin: var(--spacer-xs) auto 0 auto;

  &:first-child {
    margin-top: 0;
  }

  @include breakpoints.for-mobile {
    --notification-border-radius: 0;
    --notification-max-width: 100%;
    --notification-background: var(--c-link);
    --notification-font-size: var(--font-size--sm);
    --notification-font-family: var(--font-family--primary);
    --notification-font-weight: var(--font-weight--normal);
    --notification-padding: var(--spacer-base) var(--spacer-lg);
  }

  @include breakpoints.for-desktop {
    margin: 0 0 var(--spacer-xs) 0;
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s;

  @include breakpoints.for-desktop {
    transition: opacity 0.25s linear;
  }
}

.slide-fade-enter {
  transform: translateY(40px);

  @include breakpoints.for-desktop {
    opacity: 0;
  }
}

.slide-fade-leave-to {
  transform: translateY(80px);

  @include breakpoints.for-desktop {
    opacity: 0;
  }
}
</style>
